'use strict'

// Utilities
import { defaultObj } from './state'
import isEmpty from '../../utility/isEmpty'

export default {
  setPredictions (state, predictions) {
    if (!isEmpty(predictions)) {
      state.predictions = predictions
    }
  },

  clearPredictions (state) {
    state.predictions = []
  },

  clearPlaceDetails (state) {
    state.placeDetails = {}
  },

  setPlaceDetails (state, placeDetails) {
    if (!isEmpty(placeDetails)) {
      state.placeDetails = placeDetails
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
